<template lang="pug">
#sub-empresa-bloco-pesquisa-filtros
    .filtros
        .bloco-pesquisa-filtros__container
            .bloco-pesquisa-filtros__barra-pesquisa
                i.el-icon-search
                input(
                    v-model='pesquisa',
                    type='text',
                    :placeholder='$t("mensagens.subEmpresaGestao.placehoder.pesquisaInteligente")',
                    autocomplete='off',
                    @keyup.enter='aplicarFiltros',
                    @input='limpar'
                )

        .filtros-data
            el-date-picker.input-data-cadastro(
                v-model='dataSelecionada',
                type='daterange',
                range-separator='-',
                format='dd/MM/yyyy',
                :clearable='false',
                :start-placeholder='$t("mensagens.subEmpresaGestao.placehoder.dataInicio")',
                :end-placeholder='$t("mensagens.subEmpresaGestao.placehoder.dataFim")',
                size='large',
                @change='aplicarFiltros'
            )

        section
            el-popover(
                placement='bottom',
                width='600',
                trigger='click',
                @show='obterDadosFiltro'
            )
                el-button.button-outline(
                    icon='lyra-icon lyra-filtro',
                    name='filtro',
                    plain,
                    slot='reference'
                ) {{ $t('mensagens.subEmpresaGestao.placehoder.filtros') }}

                el-form(label-position='top')
                    .filtros-avancados__titulo
                        p {{ $t('mensagens.subEmpresaGestao.filtrosAvancados.titulo') }}

                    .filtros-avancados__collapse
                        el-collapse(v-model='collapse', accordion)
                            el-collapse-item(
                                :title='$t("mensagens.subEmpresaGestao.filtrosAvancados.safra")',
                                name='safra'
                            )
                                el-checkbox-group.filtros-avancados__opcoes(
                                    v-model='safraSelecionada',
                                    v-loading='carregandoSafra'
                                )
                                    el-checkbox.filtros-avancados__opcao(
                                        v-for='safra in safras',
                                        :label='safra.ano',
                                        :key='safra.id',
                                        :value='safra.ano',
                                        @change='aplicarFiltros'
                                    ) {{ safra.ano }}

                            el-collapse-item(
                                :title='$t("mensagens.subEmpresaGestao.filtrosAvancados.status")',
                                name='status'
                            )
                                el-checkbox-group.alinhamento-status.filtros-avancados__opcoes(
                                    v-model='statusSelecionado',
                                    v-loading='carregandoStatusEmpresa'
                                )
                                    el-checkbox.filtros-avancados__opcao(
                                        v-for='status in statusEmpresa',
                                        :label='status.codigo',
                                        :key='status.codigo',
                                        :value='status.descricao',
                                        @change='aplicarFiltros'
                                    ) {{ $t(`mensagens.subEmpresaGestao.status.${status.codigo}`) }}

                            el-collapse-item(
                                v-if='isUsuarioLDC',
                                title='Trading',
                                name='subTrading'
                            )
                                el-checkbox-group.filtros-avancados__opcoes(
                                    v-model='subTradingSelecionado',
                                    v-loading='carregandoSubTrading'
                                )
                                    el-checkbox.filtros-avancados__opcao(
                                        v-for='subTrading in subTradings',
                                        :label='subTrading.nome',
                                        :key='subTrading.nome + subTrading.id',
                                        :value='subTrading.id',
                                        @change='aplicarFiltros'
                                    ) {{ subTrading.nome }}

                            el-collapse-item.estados-municipios-filtro(
                                :title='$t("mensagens.subEmpresaGestao.filtrosAvancados.localidade")',
                                name='municipio'
                            )
                                .estados-filtro
                                    p.sub-titulo {{ $t('mensagens.subEmpresaGestao.filtrosAvancados.selectDepartamento') }}
                                    el-select#estado(
                                        v-model='localidadeNivelUmSelecionado',
                                        :loading='carregandoLocalidadeNivelUm',
                                        @change='aplicarFiltros',
                                        @clear='limparLocalidadeNivelUm',
                                        clearable,
                                        filterable
                                    )
                                        el-option(
                                            v-for='{ sigla, id } in localidadeNivelUm',
                                            :key='id + sigla',
                                            :id='"estado-" + sigla',
                                            :label='sigla',
                                            :value='id'
                                        )

    .bloco-pesquisa-filtros__filtros-selecionados.mt-3(v-if='tags.length')
        span.filtros-selecionados__titulo {{ $t('mensagens.subEmpresaGestao.filtrosAvancados.filtrosSelecionados') }}
        el-tag.filtros-selecionados__tags(
            v-for='(tag, index) in tags',
            :key='index',
            closable='',
            type='success',
            @close='removerFiltro(tag)'
        )
            span {{ traduzirTag(tag) }}

        el-tag.filtros-selecionados__limpar(
            v-if='tags.length',
            type='info',
            @click='limparFiltros'
        ) {{ $t('mensagens.subEmpresaGestao.filtrosAvancados.limparFiltros') }}
            i.el-icon-delete
</template>

<script>
import ContratoOriginacaoService from '@/services/ContratoOriginacaoService';
import ContratoOriginacaoServiceSubEmpresa from '@/services/ContratoOriginacaoServiceSubEmpresa';
import LocalidadeService from '@/services/LocalidadeService';
import { mapState } from 'vuex';

export default {
    name: 'BlocoPesquisaInteligenteFiltrosPY',
    data() {
        return {
            collapse: null,
            tags: [],
            statusEmpresa: [],
            safras: [],
            localidadeNivelUm: [],
            localidadeNivelDois: [],
            safraSelecionada: [],
            statusSelecionado: [],
            subTradingSelecionado: [],
            dataSelecionada: '',
            localidadeNivelUmSelecionado: '',
            localidadeNivelDoisSelecionado: [],
            pesquisa: '',
            subTradings: [],
            carregandoStatusEmpresa: false,
            carregandoSafra: false,
            carregandoLocalidadeNivelUm: false,
            carregandoLocalidadeNivelDois: false,
            carregandoSubTrading: false
        };
    },
    computed: {
        ...mapState(['usuarioLogado']),
        isUsuarioLDC() {
            return this.usuarioLogado?.isLDCRevenda === true;
        }
    },
    methods: {
        aplicarFiltros() {
            this.tags = [];
            if (this.safras.length) this.tags.push(...this.safraSelecionada);
            // eslint-disable-next-line
            if (this.statusSelecionado.length) {
                this.tags.push(...this.statusSelecionado);
            }

            if (this.localidadeNivelUmSelecionado) {
                const departamento = this.localidadeNivelUm.find(
                    departamento =>
                        departamento.id === this.localidadeNivelUmSelecionado
                );
                this.tags.push(departamento.nome);
            }

            if (this.subTradingSelecionado.length) {
                const subTradingNomes = this.subTradingSelecionado.map(id => {
                    const subTrading = this.subTradings.find(st => st.id === id);
                    return subTrading ? subTrading.nome : null;
                }).filter(nome => nome !== null);
                this.tags.push(...subTradingNomes);
            }

            if (this.dataSelecionada && this.dataSelecionada.length === 2) {
                const formatarData = dataISO => {
                    const data = new Date(dataISO);
                    const dia = String(data.getDate()).padStart(2, '0');
                    const mes = String(data.getMonth() + 1).padStart(2, '0');
                    const ano = data.getFullYear();
                    return `${dia}/${mes}/${ano}`;
                };

                const dataInicio = formatarData(this.dataSelecionada[0]);
                const dataFim = formatarData(this.dataSelecionada[1]);

                const intervaloFormatado = `${dataInicio} - ${dataFim}`;
                this.tags.push(intervaloFormatado);
            }

            const filtro = {
                safras: this.obterIdsSafra(),
                status: this.obterIdsStatus(),
                dataCadastroInicio: this.converterData(this.dataSelecionada[0]),
                dataCadastroFim: this.converterData(this.dataSelecionada[1]),
                pesquisa: this.obterPesquisa(),
                idLocalidadeNivelUm: this.localidadeNivelUmSelecionado,
                subTradings: this.obterIdsSubTrading()
            };
            this.$emit('emitFiltros', filtro);
        },
        converterData(date) {
            if (!this.dataSelecionada.length) return '';
            return new Date(date).getTime();
        },
        obterIdsStatus() {
            if (!this.statusSelecionado) return [];
            return this.statusSelecionado.map(codigo => {
                const statusObjeto = this.statusEmpresa.find(
                    objeto => objeto.codigo === codigo
                );
                return statusObjeto ? statusObjeto.codigo : null;
            });
        },
        obterIdsSafra() {
            if (!this.safraSelecionada) return [];
            return this.safraSelecionada.map(ano => {
                const statusObjeto = this.safras.find(
                    objeto => objeto.ano === ano
                );
                return statusObjeto ? statusObjeto.id : null;
            });
        },
        obterPesquisa() {
            if (!this.pesquisa) return '';
            return this.pesquisa;
        },

        traduzirTag(tag) {
            const status = this.statusEmpresa.find(item => item.codigo === tag);
            if (status) {
                return this.$t(
                    `mensagens.subEmpresaGestao.filtrosAvancados.statusSelecao.${tag}`
                );
            }

            return tag;
        },

        limparFiltros() {
            this.tags = [];
            this.safraSelecionada = [];
            this.statusSelecionado = [];
            this.subTradingSelecionado = [];
            this.dataSelecionada = '';
            this.pesquisa = '';
            this.localidadeNivelUmSelecionado = '';
            this.municipioSelecionado = [];
            this.aplicarFiltros();
        },

        removerFiltro(filtro) {
            this.tags.splice(this.tags.indexOf(filtro), 1);
            this.desmarcarFiltroPopover(filtro);
            this.aplicarFiltros();
        },

        desmarcarFiltroPopover(filtro) {
            const indexSafra = this.safraSelecionada.indexOf(filtro);
            if (indexSafra !== -1) {
                this.safraSelecionada.splice(indexSafra, 1);
            }

            const indexStatus = this.statusSelecionado.indexOf(filtro);
            if (indexStatus !== -1) {
                this.statusSelecionado.splice(indexStatus, 1);
            }

            const regexData = /^\d{2}\/\d{2}\/\d{4} - \d{2}\/\d{2}\/\d{4}$/;
            if (regexData.test(filtro)) {
                this.dataSelecionada = '';
            }

            if (this.municipioSelecionado.length) {
                let municipio = filtro.split(' - ');
                const indexMunicipio = this.municipioSelecionado.indexOf(
                    municipio[1]
                );
                if (indexMunicipio !== -1) {
                    this.municipioSelecionado.splice(indexMunicipio, 1);
                    if (!this.municipioSelecionado.length) {
                        this.localidadeNivelUmSelecionado = null;
                    }
                }
            }

            const subTrading = this.subTradings.find(st => st.nome === filtro);
            if (subTrading) {
                const indexSubTrading = this.subTradingSelecionado.indexOf(subTrading.id);
                if (indexSubTrading !== -1) {
                    this.subTradingSelecionado.splice(indexSubTrading, 1);
                }
            }
        },
        formatarData(data, formatDate) {
            if (data) {
                const dia = formatDate(data, 'dd');
                const mes = formatDate(data, 'MM');
                const ano = formatDate(data, 'yyyy');
                return `${dia}, ${mes}, ${ano}`;
            }
            return '';
        },
        limpar() {
            if (this.pesquisa === '') this.aplicarFiltros();
        },
        obterDadosFiltro() {
            if (this.statusEmpresa.length && this.safras.length) {
                if (this.isUsuarioLDC && !this.subTradings.length) {
                    this.buscarSubTradings();
                }
                return;
            }
            this.getStatusSubEmpresa();
            this.getSafras();
            this.buscarLocalidadeNivelUm();
            if (this.isUsuarioLDC) {
                this.buscarSubTradings();
            }
        },
        async getStatusSubEmpresa() {
            this.carregandoStatusEmpresa = true;
            try {
                const { data } =
                    await ContratoOriginacaoServiceSubEmpresa.statusSubEmpresa();

                const codesToExclude = [
                    'AJUSTADO_PELA_REVENDA',
                    'DISCREPANCIA'
                ];
                const statusFiltrado = data.filter(
                    item => !codesToExclude.includes(item.codigo)
                );
                this.statusEmpresa = statusFiltrado;
            } catch (error) {
                this.$notify.error({
                    message: 'Não foi possível buscar os dados de status.'
                });
            }
            this.carregandoStatusEmpresa = false;
        },
        async getSafras() {
            this.carregandoSafra = true;
            try {
                const { data } = await ContratoOriginacaoService.buscarSafras();

                const safrasOrdenadas = data.sort((a, b) => a.ano - b.ano);
                this.safras = safrasOrdenadas;
            } catch (error) {
                this.$notify.error({
                    message: 'Não foi possível buscar os dados de safras.'
                });
            }
            this.carregandoSafra = false;
        },
        async buscarLocalidadeNivelUm() {
            try {
                this.carregandoLocalidadeNivelUm = true;
                const { data } =
                    await LocalidadeService.buscarLocalidadeNivelUm(false);

                this.localidadeNivelUm = data;
                this.carregandoLocalidadeNivelUm = false;
            } catch (error) {
                this.$notify.error('Ocorreu um erro ao buscar os estados.');
            }
        },
        async buscarLocalidadeNivelDois() {
            this.localidadeNivelDoisSelecionado = [];

            if (!this.localidadeNivelUmSelecionado) return;

            try {
                this.carregandoLocalidadeNivelUm = true;
                const { data } =
                    await LocalidadeService.buscarLocalidadeNivelDois(
                        this.localidadeNivelUmSelecionado,
                        false
                    );

                this.localidadeNivelDois = data;
                this.carregandoLocalidadeNivelUm = false;
            } catch (error) {
                this.$notify.error('Ocorreu um erro ao buscar os municipios.');
            }
        },
        async limparLocalidadeNivelUm() {
            if (this.localidadeNivelDoisSelecionado.length) {
                this.localidadeNivelDoisSelecionado.forEach(n2 => {
                    let localidadeNivelUm = this.localidadeNivelUm.find(n1 => {
                        return n1.id === this.localidadeNivelUmSelecionado;
                    });
                    this.tags.splice(
                        this.tags.indexOf(localidadeNivelUm.sigla + ' - ' + n2),
                        1
                    );
                });
                this.localidadeNivelUmSelecionado = null;
                this.municipioSelecionado = [];
            }
            this.aplicarFiltros();
        },
        obterIdsLocalidadeNivelDois() {
            if (!this.localidadeNivelDoisSelecionado) return [];
            return this.localidadeNivelDoisSelecionado.map(nome => {
                const idObjeto = this.localidadeNivelDois.find(
                    objeto => objeto.nome === nome
                );
                return idObjeto ? idObjeto.id : null;
            });
        },
        municipioNome() {
            const nomeObjeto = this.municipios.find(
                objeto => objeto.id === this.municipioSelecionado
            );
            return nomeObjeto ? nomeObjeto.nome : null;
        },
        async buscarSubTradings() {
            try {
                this.carregandoSubTrading = true;
                const { data } = await ContratoOriginacaoService.buscarSubTradingsSubempresa();
                this.subTradings = data;
            } catch (error) {
                this.$notify.error({
                    message: 'Não foi possível buscar os dados de subTrading.'
                });
            }
            this.carregandoSubTrading = false;
        },
        obterIdsSubTrading() {
            if (!this.subTradingSelecionado) return [];
            return this.subTradingSelecionado.map(nome => {
                const subTrading = this.subTradings.find(
                    objeto => objeto.nome === nome
                );
                return subTrading ? subTrading.id : null;
            }).filter(id => id !== null);
        }
    }
};
</script>

<style lang="scss">
body {
    overflow-y: hidden;
    overflow-x: hidden;
}
.filtros {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    gap: 10px;
}

.bloco-pesquisa-filtros__container {
    width: 100%;
    height: 42px;
    border-radius: 5px;
    background: var(--white);
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    position: relative;
}

.filtros-data {
    box-shadow: 0px 0px 10px rgb(0 0 0 / 10%);
}

.input-data-cadastro {
    height: 43px !important;
    .el-input__inner {
        height: 43px !important;
    }
}

.bloco-pesquisa-filtros__barra-pesquisa {
    height: 100%;
    display: flex;
    justify-content: center;

    i.el-icon-search {
        color: var(--gray);
        font-size: 16px;
        display: flex;
        align-items: center;
        margin: 0 8px;
    }

    input {
        width: 100%;
        height: 100%;
        border: none;
        outline: none;
        border-radius: 5px;
        color: var(--primary);
    }
}

.bloco-pesquisa-filtros__filtros-selecionados {
    display: flex;
    align-items: center;
    gap: 4px;
    flex-wrap: wrap;
}

.filtros-selecionados__limpar {
    cursor: pointer;
}

.filtros-avancados__titulo {
    color: var(--primary);
    font-weight: bold;
}

.filtros-avancados__opcoes {
    font-size: 0;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
}

.el-collapse-item.estados-municipios-filtro.is-active,
.el-collapse-item.estados-municipios-filtro {
    .el-collapse-item__content {
        display: flex;
        gap: 15px;
        padding-bottom: 25px;
        font-size: 13px;
        color: #303133;
        line-height: 1.7692307692;

        .sub-titulo {
            margin: 0;
            color: #808080;
        }

        .municipios-filtro,
        .estados-filtro {
            display: flex;
            flex-direction: column;
        }
    }
}
</style>
